import GeckoEvents, { useEvent, useEventCallback } from '../gecko-events';
import { GeckoToastService } from 'ui';
import { onBootstrap } from '../bootstrap';
import GeckoStore from '../gecko-store';
import { useEffect, useReducer } from 'react';

function executionReducer(execution, { type, payload }) {
  switch (type) {
    case 'STATUS_CHANGED':
      return Object.assign({}, execution, { status: payload });
    case 'PROGRESS_CHANGED':
      return Object.assign({}, execution, { progress: payload });
    case 'REPLACE_EXECUTION':
      return payload;
    default:
      throw new Error();
  }
}
export function useWatchedExportExecution(execution = {}) {
  const [watchedExecution, dispatch] = useReducer(executionReducer, execution);

  const onMovedToInProgress = useEventCallback(
    ({ id, status }) => {
      if (!watchedExecution) {
        return;
      }
      if (id !== watchedExecution.id) {
        return;
      }
      dispatch({ type: 'STATUS_CHANGED', payload: status });
      dispatch({ type: 'PROGRESS_CHANGED', payload: 0 });
    },
    [watchedExecution]
  );

  const onProgressed = useEventCallback(
    ({ id, progress }) => {
      if (!watchedExecution) {
        return;
      }
      if (id !== watchedExecution.id) {
        return;
      }
      dispatch({ type: 'STATUS_CHANGED', payload: 'In progress' });
      dispatch({ type: 'PROGRESS_CHANGED', payload: progress });
    },
    [watchedExecution]
  );

  const onFailed = useEventCallback(
    ({ id, status }) => {
      if (!watchedExecution) {
        return;
      }
      if (id !== watchedExecution.id) {
        return;
      }
      dispatch({ type: 'STATUS_CHANGED', payload: status });
    },
    [watchedExecution]
  );

  const onCompleted = useEventCallback(
    ({ id, status }) => {
      if (!watchedExecution) {
        return;
      }
      if (id !== watchedExecution.id) {
        return;
      }
      dispatch({ type: 'STATUS_CHANGED', payload: status });
    },
    [watchedExecution]
  );

  useEffect(() => {
    dispatch({ type: 'REPLACE_EXECUTION', payload: execution });
  }, [execution.id]);
  useEvent('export-execution:moved-to-in-progress', onMovedToInProgress);
  useEvent('export-execution:progressed', onProgressed);
  useEvent('export-execution:failed', onFailed);
  useEvent('export-execution:completed', onCompleted);
  return watchedExecution;
}

onBootstrap(() => {
  return GeckoEvents.subscribe(
    'export-execution:completed',
    ({ started_by }) => {
      const user = GeckoStore.redux.get('appState.loggedInUser');
      if (started_by === user.id) {
        new GeckoToastService().success(
          `Your export has successfully processed and sent to ${user.email} where it can be downloaded.`
        );
      }
    }
  );
});

onBootstrap(() => {
  return GeckoEvents.subscribe('export-execution:failed', ({ started_by }) => {
    const user = GeckoStore.redux.get('appState.loggedInUser');
    if (started_by === user.id) {
      new GeckoToastService().error(`Your last export has failed`);
    }
  });
});
